import ManageColor from './ManageColour.svg';
import ManageDark from './ManageDark.svg';
import ManageLight from './ManageLight.svg';
export const manage = { color: ManageColor, dark: ManageDark, light: ManageLight };
//# sourceMappingURL=index.js.map